import { gql } from 'urql';

const StartRDC = gql`
  mutation StartRDC($input: StartRdcInput!) {
    startRdc(input: $input) {
      __typename
      ... on StartRdcSuccess {
        session
      }
      ... on Error {
        code
        title
        message
      }
    }
  }
`;

export default StartRDC;
